import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE_URL } from "@/lib/seo";

// Keeps a single self-referencing canonical <link> (non-www) in sync on every route.
// Pages set their own title/description via usePageMeta; this fills the canonical gap.
export default function RouteSeo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    let el = document.querySelector('link[rel="canonical"]');
    if (!el) {
      el = document.createElement("link");
      el.setAttribute("rel", "canonical");
      document.head.appendChild(el);
    }
    el.setAttribute("href", `${SITE_URL}${path}`);
  }, [pathname]);
  return null;
}
